import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Mail, X, MessageCircle } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

export default function FloatingContact() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            className="mb-4"
          >
            <div className="glass-card p-4 space-y-3 min-w-[200px]">
              <a
                href="tel:+642102984443"
                onClick={() => trackEvent("contact_click", { method: "phone", source: "floating_contact" })}
                className="flex items-center gap-3 p-3 rounded-lg hover:bg-white/10 transition-colors group"
              >
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-white transition-colors">
                  <Phone className="w-5 h-5 text-white group-hover:text-black" />
                </div>
                <div>
                  <span className="block text-xs text-white/60">Call Us</span>
                  <span className="font-bold text-sm">+64 021 029 84443</span>
                </div>
              </a>

              <a
                href="mailto:admin@craftcivil.co.nz?subject=Website%20Enquiry%20-%20Craft%20Civil"
                onClick={() => trackEvent("contact_click", { method: "email", source: "floating_contact" })}
                className="flex items-center gap-3 p-3 rounded-lg hover:bg-white/10 transition-colors group"
              >
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-white transition-colors">
                  <Mail className="w-5 h-5 text-white group-hover:text-black" />
                </div>
                <div>
                  <span className="block text-xs text-white/60">Email Us</span>
                  <span className="font-bold text-sm truncate max-w-[120px]">
                    admin@craftcivil.co.nz
                  </span>
                </div>
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? "Close quick contact menu" : "Open quick contact menu"}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className={`relative w-16 h-16 rounded-full shadow-lg flex items-center justify-center transition-colors duration-300 ${
          isOpen
            ? "bg-white text-black"
            : "bg-gradient-to-br from-white to-gray-300 text-black"
        }`}
        style={{ boxShadow: "0 4px 30px rgba(255, 255, 255, 0.2)" }}
      >
        <AnimatePresence mode="wait">
          {isOpen ? (
            <motion.div
              key="close"
              initial={{ rotate: -90, opacity: 0 }}
              animate={{ rotate: 0, opacity: 1 }}
              exit={{ rotate: 90, opacity: 0 }}
            >
              <X className="w-8 h-8" />
            </motion.div>
          ) : (
            <motion.div
              key="open"
              initial={{ rotate: 90, opacity: 0 }}
              animate={{ rotate: 0, opacity: 1 }}
              exit={{ rotate: -90, opacity: 0 }}
            >
              <MessageCircle className="w-8 h-8" />
            </motion.div>
          )}
        </AnimatePresence>

        {!isOpen && (
          <motion.div
            className="absolute inset-0 rounded-full border-2 border-white/50"
            animate={{ scale: [1, 1.5], opacity: [0.5, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
          />
        )}
      </motion.button>
    </div>
  );
}
